<div class="flex flex-col justify-start text-md w-[374px] gap-4">
    <!-- General Set Info & Child Sets -->
    <div class="flex flex-col w-full rounded-md shadow bg-ponder-light">
        <div class="flex flex-row gap-2 p-2 pb-1 text-slate-50">
            <magic-set-icon [setCode]="magicSet!.code!" rarity="display"></magic-set-icon>
            <div class="truncate">{{ magicSet!.name}} ({{ magicSet!.code!.toUpperCase() }})</div>
        </div>
        <div class="pb-1">
            <table class="table-auto text-xs text-slate-200 truncate rounded-b-md">
                <tbody>
                    <tr class="bg-ponder-light">
                        <td class="pl-2 pr-2">{{ magicSet!.releaseDate | date }}</td>
                        <td class="pl-2 pr-2">{{ getCount() }} cards</td>
                        <td class="pl-2 pr-2">{{ getValue() }}</td>
                        <td class="pl-2 pr-2 w-full text-foil">{{ getSpecialValue() }}</td>
                    </tr>
                    @if (hasAuth()) {
                    <tr class="bg-ponder-xlight rounded-b-md">
                        <td class="pl-2 pr-2">Collected</td>
                        <td class="pl-2 pr-2">
                            <div class="flex flex-row gap-2 ">
                                <div>{{ getDistinctCollectedCount() }} cards</div>
                                @if (hasCollected()) { <div class="text-slate-200 text-opacity-70">({{ getCollectedCount() }} total)</div> }
                            </div>
                        </td>
                        <td class="pl-2 pr-2">@if (hasCollected()) { {{ getCollectedValue() }} }</td>
                        <td class="pl-2 pr-2"></td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="rounded-b bg-slate-100 ">
            @if (childSets) {
                <div class="flex flex-col pt-1 pb-1 max-h-[300px] overflow-y-auto rounded-b text-sm">
                    <div class="flex flex-row gap-2 items-center font-bold p-1 pl-2 pr-2">
                        <div class="w-[2ch]"></div>
                        <div class="grow">Set</div>
                        <div class="w-[12ch]">Released</div>
                    </div>
                    <!-- Parent Set (this) -->
                    <div class="flex flex-row gap-2 items-center font-bold p-[2px] pl-2 pr-2 border-t-[1px] bg-slate-50 hover:bg-ponder-linkhover hover:bg-opacity-15">
                        <input type="checkbox" (change)="onSetSelected(magicSet.code!)">
                        <div class="grow">{{ magicSet.name! }}</div>
                        <div class="w-[12ch]">{{ magicSet.releaseDate! | date }}</div>
                    </div>
                    <!-- Child Sets -->
                    @for (child of childSets; track child.id) {
                        @if (!isFiltered(child)) {
                            <div class="flex flex-row gap-2 items-center p-[2px] pl-2 pr-2 border-t-[1px] bg-slate-50 hover:bg-ponder-linkhover hover:bg-opacity-15">
                                <input type="checkbox" (change)="onSetSelected(child.code!)">
                                <a href="/magic/set/{{ child.code! }}" class="grow line-clamp-1 w-[25ch]">{{ child.name! }}</a>
                                <div class="w-[12ch]">{{ child.releaseDate! | date }}</div>
                            </div>
                        }
                    }
                </div>
                @if (allSelectedSets.length > 0) {
                    <div class="text-sm border-t-[1px] rounded-b">
                        <div (click)="onViewSelectedSets()" class="pl-4 pt-1 pb-1 hover:bg-ponder-linkhover hover:bg-opacity-15 cursor-pointer">
                            @if (allSelectedSets.length == 1) {
                                → View Selected Set
                            } @else {
                                → View Selected Sets ({{ allSelectedSets.length }})
                            }
                        </div>
                    </div>
                }
                @if (childSets.length > 10) {
                    <div class="items-center text-sm p-1 pl-2 pr-2">
                        <input #setFilter (input)="onFilterUpdated(setFilter.value)" class="p-1 bg-slate-50 rounded-sm shadow-sm w-full" placeholder="Filter ...">
                    </div>
                }
            }
        </div>
    </div>
    <!-- Set Decks -->
     <magic-set-decks [setCode]="magicSet.code!"></magic-set-decks>
</div>